import useSWR from 'swr';
import { Grid, Button, Flex, useToast } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Loader from '../../components/Feedback/Loader';
import { MainContent, PageHeaderStructure } from '../../components/Layout';
import { pageHeaderContent } from '../../resources/content';
import { CertificationResume } from '../../components/Card';
import { fetchData } from '../../services/fetch';
import { useState } from 'react';
import baseService from '../../services/base';
import { AttentionModal, SuccessModal, SealModelsModal } from '../../components/Modals';

export default function Certifications() {
 const [currentCertification, setCurrentCertification] = useState();
 const [deleteSubmitIsLoading, setDeleteSubmitIsLoading] = useState(false);
 const [deleteConfirmationIsOpen, setDeleteConfirmationIsOpen] = useState(false);
 const [success, setSuccess] = useState(false);
 const [sealModelsIsOpen, setSealModelsIsOpen] = useState(false);

 const colors = ['#0073BB', '#598F3C', '#00B2EF', '#64645e'];
 const { data: certificationsData, isLoading, mutate } = useSWR(`/certificate/grouped-by-survey`, fetchData);
 // Guard: se a API devolver algo que não é array (erro/restart), não quebra a tela.
 const certifications = Array.isArray(certificationsData) ? certificationsData : [];
 const { data: defaultAssets } = useSWR('/certificate/assets/default', fetchData);
 const toast = useToast();

 function openDeleteConfirmation(certification) {
  setCurrentCertification(certification.id);
  setDeleteConfirmationIsOpen(true);
 }

 const handleDelete = async () => {
  setDeleteSubmitIsLoading(true);
  try {
    await baseService.delete(`/certificate/${currentCertification}`);
    setDeleteConfirmationIsOpen(false);
    setSuccess(true);
  } catch (err) {
    toast({
      title: 'Erro ao excluir certificação',
      description:
        'Não é permitido deletar certificações com perguntas cadastradas. Contate uma pessoa administradora.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  } finally {
    setDeleteSubmitIsLoading(false);
  }
 };

 const handleClose = () => {
  mutate();
  setDeleteConfirmationIsOpen(false);
  setSuccess(false);
 };

 if (isLoading) {
  return <Loader />;
 }

 return (
  <MainContent>
   <PageHeaderStructure title={pageHeaderContent.certification.title}>
    <Flex gap='12px' align='center' flexShrink={0}>
     <Button
      onClick={() => setSealModelsIsOpen(true)}
      width='200px'
      height='59px'
      bg='#EAF3FB'
      color='#0073BB'
      border='2px solid #0073BB'
      fontWeight={700}
      borderRadius='10px'
      _hover={{ bg: '#DCEBFA' }}
     >
      Selos padrão
     </Button>
     <Button variant='primary' as={Link} to='create' width='235px' height='59px'>
      Cadastrar Certificação
     </Button>
    </Flex>
   </PageHeaderStructure>

   <Grid templateColumns='repeat(2, 1fr)' gap='12px' mt='32px'>
    {certifications?.map((certification, index) => (
     <CertificationResume
      key={certification?.id}
      id={certification?.id}
      name={certification?.name}
      color={colors[index % colors.length]}
      sealUrl={certification?.seal_url || defaultAssets?.seal?.url}
      isDefaultSeal={!certification?.seal_url && !!defaultAssets?.seal?.url}
     >
      <Button
       onClick={() => openDeleteConfirmation(certification)}
       variant="outline"
       w="141px"
       border={`1px solid white`}
       pos="absolute"
       bottom="25px"
       color={'white'}
       left="6"
       borderRadius="10px"
       zIndex={3}
       _hover={{
         bg: 'none',
       }}
       >
       Remover
      </Button>
     </CertificationResume>
    ))}
   </Grid>

   <AttentionModal
    isOpen={deleteConfirmationIsOpen}
    submit={handleDelete}
    onClose={() => setDeleteConfirmationIsOpen(false)}
    title="Deseja excluir essa certificação?"
    isLoading={deleteSubmitIsLoading}
   />

   <SuccessModal
    isOpen={success}
    onClose={handleClose}
    title="Certificação removida com sucesso"
   />

   <SealModelsModal
    isOpen={sealModelsIsOpen}
    onClose={() => setSealModelsIsOpen(false)}
   />
  </MainContent>
 );
}